import React, { useEffect, useState } from 'react';

import styles from './DesktopCartProducts.module.css'
import { CartProduct } from "../../../../../widgets/ProductCard/types/productCard.interface.ts";
import {
    closeIcon,
} from "../../../../../assets/icons/icons.ts";
import { Tooltip } from "../../../../../ui/Feedback/Tooltip/Tooltip.tsx";
import { Checkbox } from "../../../../../ui/Filters/components/Checkbox/Checkbox.tsx";
import { CartNoProducts as NoProducts } from "./components/CartNoProducts/CartNoProducts.tsx";
import { Button } from "../../../../../ui/General/Button/Button.tsx";
import { cn } from "../../../../../utils/cn.ts";
import { AmountCounter } from "../components/AmountCounter/AmountCounter.tsx";
import { useToggleSet } from "../../../../../hooks/useSet.tsx";
import { Loader } from "../../../../../ui/Loader/Loader.tsx";
import { formatToLocaleString } from '../../../../../utils/formatters/formatToLocaleString.ts';
import { replaceCartElementRequest } from '@/utils/requests/cart/replaceCartElementRequest.ts';
import { useAppDispatch } from '@/utils/storage/stores/store.ts';
import { cartOfferLoader } from '@/utils/storage/extra/loaders/cart/cartOfferLoader.ts';
interface Props {
    cartProducts: CartProduct[],
    addOrLessenProduct: (elementId: number, operation: ProductOperation) => void,
    removeProducts: (ids: number[]) => void,
    setShowWarning: (showWarning: boolean) => void,
    cartId: number,
}

interface PropsProduct {
    product: CartProduct,
    addOrLessenProduct: (elementId: number, operation: ProductOperation) => void,
    removeProducts: (ids: number[]) => void,
    toggle: (id: number) => void,
    setShowWarning: (showWarning: boolean) => void,
    checked: (id: number) => boolean,
    cartId: number,
    idx: number,
    ids: number[],
}

type ProductOperation = 'add' | 'remove'

const Product: React.FC<PropsProduct> = ({
    product,
    addOrLessenProduct,
    removeProducts,
    cartId,
    toggle,
    idx,
    ids,
    setShowWarning,
    checked,
}) => {
    const dispatch = useAppDispatch();
    const {
        id,
        name,
        brand,
        article,
        price,
        amount,
        stock,
        isAvailable
    } = product;

    const [isEditMode, setIsEditMode] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [failedReplace, setFailedReplace] = useState<boolean>(false);

    const replaceItem = (id: number) => {
        setIsLoading(true);
        replaceCartElementRequest(id)
            .then(() => {
                dispatch(cartOfferLoader({cartId, isMini: false, all: true}));
            })
            .catch(error => {
                console.error(error);
                setFailedReplace(true);
                setShowWarning(true);
            })
            .finally(() => setIsLoading(false));
        // replaceCartElement(cartId, id)
        //     .catch(() => {
        //         setShowWarning(true);
        //         setFailedReplace(true);
        //     })
        //     .then(() => setIsLoading(false))
    }

    return (
        <li
            className={cn(styles.product, !isAvailable && styles.productNotAvailable)}
        >
            <div className={styles.info}>
                <div className={styles.name}>
                    {isEditMode ? (
                        <Checkbox
                            checked={checked(id)}
                            onChange={() => toggle(id)}
                        />
                    ) : <span className={styles.nameCounter}>{++idx}. </span>}
                    {name}
                </div>
                <div className={styles.infoBottom}>
                    <div className={styles.brand}>{brand}</div>
                    <div className={styles.productId}>{article}</div>
                </div>
            </div>
            <div className={styles.price}>{formatToLocaleString(String(price))} ₽</div>
            {isAvailable ? <AmountCounter
                price={price}
                amount={amount}
                stock={stock}
                add={() => addOrLessenProduct(id, 'add')}
                remove={() => addOrLessenProduct(id, 'remove')}
            />
                : <Button
                    className={cn(styles.btn, styles.btnNewOffers)}
                    type='regular'
                    onClick={() => replaceItem(id)}
                >
                    {isLoading ? <><Loader /> Производится поиск</> : (failedReplace ? <>Варианты не найдены</> : <>Найти новые предложения</>)}

                </Button>
            }
            <Tooltip
                className={styles.tooltip}
                question='Удалить товар из корзины?'
                onConfirm={() => {
                    removeProducts(ids)
                    setIsEditMode(false)
                }}
                onOpen={() => {
                    setIsEditMode(true)
                    toggle(id)
                }}
                onClose={() => {
                    setIsEditMode(false)
                }}
            >
                <img
                    className={styles.closeBtn}
                    src={closeIcon}
                    alt='Удалить товар'
                />
            </Tooltip>

            <div className={styles.outline} />
        </li>
    );
}
export const DesktopCartProducts: React.FC<Props> = ({
    addOrLessenProduct,
    removeProducts,
    cartId,
    cartProducts,
    setShowWarning
}) => {
    const [products, setProducts] = useState<CartProduct[]>([]);

    const { toggle, has: checked, items: ids } = useToggleSet<number>();

    useEffect(() => {
        setProducts(cartProducts)
    }, [cartProducts]);

    return (<>
        <div className={styles.wrapper}>
            {0 === products.length ?
                <NoProducts />
                :
                (<>
                    <ul className={styles.productList}>
                        {products.map((product, idx) => (
                            <Product
                                key={product.id}
                                idx={idx}
                                ids={ids}
                                toggle={toggle}
                                checked={checked}
                                addOrLessenProduct={addOrLessenProduct}
                                removeProducts={removeProducts}
                                cartId={cartId}
                                product={product}
                                setShowWarning={setShowWarning}
                            />
                        ))}
                    </ul>
                </>)
            }
        </div>
    </>
    );
};